import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { pillars, steps } from '../../data/content';
export function Method() {
  return <section className="w-full bg-cream py-14 sm:py-20" data-id="element-202" data-mp="2ap0sscozlil7">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-203" data-mp="2anfz0pahy3oe">
        <SectionHeading eyebrow="🦷 Why it’s different" title="It wasn’t designed to make you read more. It was designed to help you organize better." data-id="element-204" data-mp="26o725bk5tpom" />

        <ul className="mt-10 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-205" data-mp="1wprcld0s6oh8">
          {pillars.map(pillar => <li key={pillar.title} className="flex h-full flex-col rounded-2xl border border-navy-100 bg-white p-5" data-id="element-206" data-mp="1rpmwvp7p5xs2">
              <h3 className="font-display text-lg font-black uppercase tracking-tight text-sky-600" data-id="element-207" data-mp="1nr5z3wa61znb">
                {pillar.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-navy-600" data-id="element-208" data-mp="3i3vpi41bsqpy">
                {pillar.text}
              </p>
            </li>)}
        </ul>

        <div className="mt-14" data-id="element-209" data-mp="3chgntzdt9gxd">
          <SectionHeading eyebrow="The 15-minute case organization system" title="Here’s how the core system works" data-id="element-210" data-mp="3cirnbn0842io" />

          <ol className="mx-auto mt-8 flex max-w-3xl flex-col gap-3" data-id="element-211" data-mp="32jkd38oscnzs">
            {steps.map(item => <li key={item.step} className="flex items-start gap-4 rounded-2xl bg-white p-4 sm:p-5" data-id="element-212" data-mp="3q9ep5o1a68iz">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-navy-800 font-display text-base font-black text-white" data-id="element-213" data-mp="3v7pylxnnyh0o">
                  {item.step.replace('Step ', '')}
                </span>
                <div className="min-w-0" data-id="element-214" data-mp="3lg21ph8c87rt">
                  <h3 className="font-display text-base font-black uppercase tracking-tight text-navy-800 sm:text-lg" data-id="element-215" data-mp="d2cwi5e8ixl2">
                    {item.title}
                  </h3>
                  <p className="mt-0.5 text-sm leading-relaxed text-navy-600 sm:text-base" data-id="element-216" data-mp="rp1we8cefcrz">
                    {item.text}
                  </p>
                </div>
              </li>)}
          </ol>
        </div>

        <p className="mx-auto mt-10 max-w-xl text-center font-display text-xl font-black uppercase leading-tight text-navy-800 sm:text-2xl" data-id="element-217" data-mp="inu7uhzopqb3">
          One case. One system. One structured workflow.
          <span className="mt-2 block text-sky-600" data-id="element-218" data-mp="8qpp6s51scz1">
            Organize your case in less than 15 minutes.
          </span>
        </p>

        <div className="mt-8 flex justify-center" data-id="element-219" data-mp="3yfwx5ggn0tl">
          <CTAButton label="Get Aligner Control System™" data-id="element-220" data-mp="3w2qlzw7o25q3" />
        </div>
      </div>
    </section>;
}